import React from 'react';
import { Field } from 'formik';

import { reasons } from '../../../helpers/order';
import DeviceObject from '../../../components/DeviceObject';
import Required from '../../../helpers/validation/required';

import SelectReason from './SelectReason';

const vMakeASelection = Required()('Please make a selection to continue');

const SelectedDevices = ({ devices }) => (
  devices.map((device, index) => (
    <div key={device.serialNumber} className="card-group__item">
      <div className="card card--secondary card--flex">
        <div className="card__content">

          <div className="return-reason">
            <div className="return-reason__device">
              <DeviceObject device={device} showSummary />
            </div>

            <div className="return-reason__select">
              <label htmlFor={`returnReasons:${device.serialNumber}`}>Reason for Return</label>
              <div className="form-control">
                <Field
                  id={`returnReasons:${device.serialNumber}`}
                  name={device.serialNumber}
                  component={SelectReason}
                  validate={vMakeASelection}
                >
                  <option disabled value="">Select a Response</option>
                  {reasons.map(reason => (
                    <option key={reason.key} value={`${reason.key}`}>{reason.value}</option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ))
);

export default SelectedDevices;
